import { SvgIcon } from '@mui/material';
import { IconProps } from './types/iconTypes';
const ArrowLeftIcon = ({
  color = '$neutrals-700',
  width = '24',
  height = '24',
  className
}: IconProps) => <SvgIcon className={className} width={`${width}px`} height={`${height}px`} viewBox={`0 0 ${width} ${height}`} data-sentry-element="SvgIcon" data-sentry-component="ArrowLeftIcon" data-sentry-source-file="ArrowLeftIcon.tsx">
		<path d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z" fill={color} data-sentry-element="path" data-sentry-source-file="ArrowLeftIcon.tsx" />
	</SvgIcon>;
export default ArrowLeftIcon;